import { render, staticRenderFns } from "./playClass.vue?vue&type=template&id=3242724d&scoped=true&"
import script from "./playClass.vue?vue&type=script&lang=ts&"
export * from "./playClass.vue?vue&type=script&lang=ts&"
import style0 from "./playClass.vue?vue&type=style&index=0&id=3242724d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3242724d",
  null
  
)

export default component.exports